import { types } from '../../types/types';

export const dispatchpending = (dispatch) => {
    dispatch({
        type: types.PENDINGTASK,
        'pendingTask': true
    });
}

export const dispatchresponse = (dispatch, data, type) => {    
    dispatch({
        type: type,
        payload: data,
        'pendingTask': false //O "end" estava dando problema de PROBE_UNKNOWN_ACTION "Number of pending tasks decreased below zero"
    });
}

export const dispatchresponseerror = (dispatch, error) => {
    dispatch({
        type: types.ERROR_NETWORK,
        payload: error.response?error.response:error,
        'pendingTask': false
    });
}